"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ParamTypeEnum = void 0;
var ParamTypeEnum;
(function (ParamTypeEnum) {
    /** 规格 */
    ParamTypeEnum["Spec"] = "spec";
    /** 数量 */
    ParamTypeEnum["Quantity"] = "quantity";
    /** 用量 */
    // Measure = 'measure',
    /** 额外规格 */
    ParamTypeEnum["ExternalParameter"] = "external-spec";
})(ParamTypeEnum || (exports.ParamTypeEnum = ParamTypeEnum = {}));
